package org.example.zone360.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun KeywordChip(keywordText: String, keywordCategory: String, sitePalette: SitePalette){
    Box {
        Box(
            modifier = Modifier.height(32.px)
                .backgroundColor(
                    when (keywordCategory) {
                       "fitness" -> sitePalette.fitnessCategoryBackground.rgb
                        "mental" -> sitePalette.mentalCategoryBackground.rgb
                       "technical" -> sitePalette.technicalCategoryBackground.rgb
                         "tactical" -> sitePalette.tacticalCategoryBackground.rgb
                         "goalkeeper"  -> sitePalette.goalKeeperCategoryBackground.rgb
                        else -> sitePalette.primary.rgb.copyf(alpha = 0.1f)
                    }
                )
                .borderRadius(7.px)
                .padding(leftRight = 8.px, topBottom = 4.px)
                .border(
                    1.px, color =
                        when (keywordCategory) {
                             "fitness"-> sitePalette.fitnessCategoryBorder.rgb
                             "mental" -> sitePalette.mentalCategoryBorder.rgb
                             "technical"  -> sitePalette.technicalCategoryBorder.rgb
                             "tactical" -> sitePalette.tacticalCategoryBorder.rgb
                             "goalkeeper"  -> sitePalette.goalKeeperCategoryBorder.rgb
                            else -> sitePalette.primary.rgb
                        }, style = LineStyle.Solid
                )
                .margin(7.px),
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                keywordText,
                modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontSize(13.px)
            )
        }
    }
}